import React, { Fragment } from 'react';
import { Row, Col,Spin, Icon } from 'antd'
import { useTranslation } from "react-i18next";
import TestDataForm from '../component/form/TestDataForm';
import { connect } from 'react-redux';
import * as serviceWorker from '../serviceWorker';
import UserSession from '../service/UserSession';
import { useQuery } from "@apollo/react-hooks";
import { GET_TOKEN_QUERY } from '../constants/graphql-query';

const DashboardContainer = ({ history, home, dispatch }) => {

  const { t } = useTranslation();

  const { loading } = useQuery(GET_TOKEN_QUERY, {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
    onCompleted: ( { getToken } ) => {
      const { token }  = getToken;
      UserSession.setSession({"token": token});
    }
   });

 
  const getTradeMark = () => <span className="sup"><font size="2">®</font></span>
  
 
  return (
    loading 
    ? (<Spin className="loading" indicator={<Icon type="loading" style={{ fontSize: 50 }} spin />} />) 
    : <Fragment>
      <div className="main-container">
        <Row className="main-title">
        <Col>{t('main.producttitle')}<span className="sup"><font size="5">®</font></span> {t('main.producttitle2')}</Col>
        </Row>
        <Row className="main-test-data">
          <Col span={24} className="sub-title">{t('main.testdatatitle')}</Col>
          <Col span={24} className="description">{t('main.testdatadesc')}{getTradeMark()} {t('main.testdatadesc2')}{getTradeMark()} {t('main.testdatadesc3')}{getTradeMark()} {t('main.testdatadesc4')}</Col>
        </Row>
        <TestDataForm
          home={home}
          dispatch={dispatch}
          t={t}
        />
      </div>
      {/* <Row className="data-matrix-title">
        <Col span={24}>{t('datatable.title')}</Col>
      </Row>
      <DataTable home={home} dispatch={dispatch} /> */}
    </Fragment>
  )
}

const mapStateToProps = state => ({
  home: state.HomeReducer
})

export default connect(mapStateToProps)(DashboardContainer);
serviceWorker.unregister();